"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

require("core-js/modules/es6.string.link");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _LogoTabsData = _interopRequireDefault(require("../config/LogoTabsData"));

require("./LogoTabs.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var _Logger = _interopRequireDefault(require("../common/util/Logger"));

var _SpoonFlowerLogo = _interopRequireDefault(require("./SpoonFlowerLogo"));

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var loggerInstance = new _Logger.default('UniversalHeader');
var cdnBaseUrl = 'https://cdn-image.staticsfly.com';
var customLogoPath = '/i/universal-header/logos/';
var _unselected = '_unselected';
var defaultImgExtension = '.png';

var generateCustomBrandLogoPath = function generateCustomBrandLogoPath() {
  var specialOccasions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var brand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.BRANDS.SHUTTERFLY;
  var isUnselected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return "".concat(cdnBaseUrl + customLogoPath + brand, "/").concat(specialOccasions).concat(isUnselected ? _unselected : '').concat(defaultImgExtension);
};

var LogoTabs = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LogoTabs, _Component);

  var _super = _createSuper2(LogoTabs);

  function LogoTabs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LogoTabs);
    _this = _super.call(this, props);
    _this.customTPImg = _react.default.createRef();
    _this.customSFLYImg = _react.default.createRef();
    _this.state = {
      selectedLogo: props.currentBrand
    };
    _this.handleLogoClick = _this.handleLogoClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LogoTabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.currentBrand !== this.props.currentBrand) {
        //this.setState({ selectedLogo: this.props.currentBrand });
        this.handleLogoClick({
          key: this.props.currentBrand
        });
      }
    }
  }, {
    key: "handleLogoClick",
    value: function handleLogoClick(brand) {
      var _this2 = this;

      if (this.state.selectedLogo !== brand.key) {
        this.setState({
          selectedLogo: brand.key
        }, function () {
          if (_this2.props.onChange) {
            _this2.props.onChange(_this2.state.selectedLogo);
          }
        });
      }

      return brand.link;
    }
  }, {
    key: "handleLogoKeyPress",
    value: function handleLogoKeyPress(e) {
      if (_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.space])) {
        e.preventDefault();
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(brand) {
      var _this3 = this;

      var isActive = this.state.selectedLogo === brand.key;
      var mobileInActive = "".concat(brand.key, "-SVG ").concat(this.state.selectedLogo && this.state.selectedLogo !== _constants.BRANDS.INC ? 'boxRightShadow' : '', " ").concat(this.props.showUnselectedLogoOnMobile || isActive ? '' : 'hide-on-mobile');

      if (this.props.showUnselectedLogo || isActive) {
        if (this.props.enableLink) {
          return _react.default.createElement("li", (0, _extends2.default)({}, brand.attr, {
            key: _Utils.default.generateKey("brands_".concat(brand.key)),
            className: mobileInActive,
            onKeyPress: this.handleLogoKeyPress
          }), _react.default.createElement("a", (0, _extends2.default)({
            href: brand.link,
            className: isActive ? 'active' : null
          }, brand.attr), this.renderBrand(brand, isActive)));
        }

        return _react.default.createElement("li", (0, _extends2.default)({
          onClick: function onClick() {
            return _this3.handleLogoClick(brand);
          },
          onKeyDown: function onKeyDown(event) {
            _Utils.default.handleKeyPress(event, function () {
              _this3.handleLogoClick(brand);
            }, [_Utils.default.keyCodeMap.enter]);
          },
          className: mobileInActive,
          key: _Utils.default.generateKey("brands_".concat(brand.key))
        }, brand.attr), _react.default.createElement("a", (0, _extends2.default)({
          target: '-blank'
        }, brand.attr), this.renderBrand(brand, isActive)));
      } else {
        return null;
      }
    }
  }, {
    key: "renderBrand",
    value: function renderBrand(brand, isActive) {
      var _this4 = this;

      var occasions = '';

      if (_constants.BRANDS.SHUTTERFLY === brand.key && this.props.sflySpecialOccasions) {
        occasions = this.props.sflySpecialOccasions;
      }

      if (_constants.BRANDS.TINYPRINTS === brand.key && this.props.tpSpecialOccasions) {
        occasions = this.props.tpSpecialOccasions;
      }

      if (occasions) {
        var url = generateCustomBrandLogoPath(occasions, brand.key, !isActive);
        return _react.default.createElement("img", {
          alt: brand.attr.alt || "".concat(brand.key, "_logo"),
          src: url,
          ref: this["custom".concat(brand.key, "Img")],
          onError: function onError(e) {
            loggerInstance.error('custom Header logo image not found', 'renderBrand', {
              message: e.message || 'custom Header logo image not found',
              type: e.type,
              brand: brand.key,
              invalidCustomLogoURL: url
            });

            if (_this4 && _this4["custom".concat(brand.key, "Img")] && _this4["custom".concat(brand.key, "Img")].current && _this4.props.isFallbackToDefaultURL) {
              _this4["custom".concat(brand.key, "Img")].current.src = brand.logo[isActive ? 'selected' : 'unSelected'].imgUrl;
            }
          }
        });
      }

      return brand.logo[isActive ? 'selected' : 'unSelected'].svg;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var isSpoonflowerDayOneEnabled = this.props.isSpoonflowerDayOneEnabled;
      return _react.default.createElement("div", {
        className: "uig-uni-header-brands-tab "
      }, _react.default.createElement("ul", {
        className: "logo-container",
        style: {
          listStyleType: 'none'
        }
      }, (0, _LogoTabsData.default)().map(function (brand) {
        return _this5.renderItem(brand);
      }), isSpoonflowerDayOneEnabled && _react.default.createElement("li", null, _react.default.createElement(_SpoonFlowerLogo.default, null))));
    }
  }]);
  return LogoTabs;
}(_react.Component);

LogoTabs.propTypes = {
  enableLink: _propTypes.default.bool,
  currentBrand: _propTypes.default.oneOf([_constants.BRANDS.SHUTTERFLY, _constants.BRANDS.TINYPRINTS, _constants.BRANDS.INC, '']),
  showUnselectedLogo: _propTypes.default.bool,
  showUnselectedLogoOnMobile: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  isSpoonflowerDayOneEnabled: _propTypes.default.bool,
  sflySpecialOccasions: _propTypes.default.string,
  tpSpecialOccasions: _propTypes.default.string,
  isFallbackToDefaultURL: _propTypes.default.bool
};
LogoTabs.defaultProps = {
  enableLink: false,
  currentBrand: '',
  showUnselectedLogo: true,
  showUnselectedLogoOnMobile: true,
  sflySpecialOccasions: '',
  tpSpecialOccasions: '',
  isSpoonflowerDayOneEnabled: false,
  isFallbackToDefaultURL: true,
  onChange: function onChange() {}
};
var _default = LogoTabs;
exports.default = _default;